import React, { memo, ReactNode } from 'react';

import { Select } from 'antd';

import EditableTable from '../../components/edit-table';
import SimpleList from '@plasma/ui.display.simple-list';
import Button from '@plasma/ui.general.button';
import Grid from '@plasma/ui.layout.grid';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';
import Input from '@plasma/ui.input.input';

import useCompanyHomeHook from './company-home.hook';
import * as styled from './company-home.styles';
import themes from './themes';
import 'antd/dist/antd.css';
const { Option } = Select;

export interface CompanyHomeProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = CompanyHomeProps & ThemeOverride;

function CompanyHome(props) {
  const {
    children,
    className,
    style,
    size,
    themeMode,
    selectedOption,
    productValue,
    sizeValue,
    familyValue,
    columnNames,
    displayDataForColumns,
    addedItems,
    productFamiliesList,
    productTypesList,
    selectedProductDescriptions_optionsList,
    hiddenColumns,
    selectedBilletOption,
    selectedFamilyProductType,
    handleSelectChange,
    handleFamilyChange,
    handleProductChange,
    handleSizeChange,
    handleAdd,
    handleSelectBilletChange,
    familyProductDescription_optionsList,
    handleRemove,billetData,
    sideOpen, setSideOpen,
    handleshowDifferences,
    showDifferences
  } = useCompanyHomeHook(props);

  const layout = [
    { i: 'dropdowns', x: 0, y: 0, w: sideOpen ? 2.25 : 1.5, h: sideOpen ? 17 : 1 },
    { i: 'datagrid', x: 3, y: 0, w: sideOpen ? 9.75 : 12, h: sideOpen ? 17 : 16 },
  ];

  const company = sessionStorage.getItem('company');

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.CompanyHome className={`company-home ${className ?? ''}`.trim()} style={style}>
        <Grid
          id="1"
          layout={layout}
          autoSize={true}
          isDraggable={false}
        >
          {/* Sidebar for Select and Buttons */}
          {sideOpen ? (
          <div key="dropdowns" >

            <div key="dropdowns_container1" style={{border: '1px solid lightgray', padding: '5px', margin:'2px'}}>

              <div style={{margin: '5px', display:'flex'}}>
                <Button
                  title='Choose Profile, Family and Billet'
                  key="insertUpButton"
                  type="ghost"
                  size="small"
                  onClick={(e) =>setSideOpen(!sideOpen)}
                  prefixIcon={{name: 'keyboard_double_arrow_left'}}
                />

              </div>
              <Select
                style={{ width: '150px', margin: '5px' }}
                onChange={handleSelectChange}
                value={selectedOption}
                placeholder="Family or Profile"
                dropdownStyle={{minWidth:'300px'}}
              >
                <Option key={1} value={'FAMILY'}>
                  {'Family'}
                </Option>
                <Option key={2} value={'PROFILE'}>
                  {'Profile'}
                </Option>
              </Select>

              <Select
                style={{ width: '150px', margin: '5px' }}
                onChange={handleSelectBilletChange}
                value={billetData}
                placeholder="Billet"
                dropdownStyle={{minWidth:'300px'}}
              >
                {selectedBilletOption && selectedBilletOption?.map((billet, index) => (
                  <option key={index} value={billet}>
                    {billet}
                  </option>
                ))}

                </Select>
              <br />

            </div>

            {selectedOption &&
            <div key="dropdowns_container" style={{border: '1px solid lightgray', padding: '5px', margin:'2px'}}>

            {selectedOption === 'FAMILY' && (
              <div>
                <div style={{margin: '5px', borderBottom: '1px solid lightgray'}}>Select Family</div>
              <Select
                style={{ width: '150px', margin: '5px' }}
                onChange={handleFamilyChange}
                value={familyValue}
                placeholder="Family Name"
                dropdownStyle={{minWidth:'300px'}}
              >
                {productFamiliesList?.map((familyName, index) => (
                  <Select.Option key={index} value={familyName}>
                    {familyName}
                  </Select.Option>
                ))}
              </Select>
              <Select
                  style={{ width: '150px', marginLeft: '5px' }}
                  onChange={handleSizeChange}
                  value={sizeValue}
                  placeholder="Size"
                  dropdownStyle={{minWidth:'300px'}}
                >
                  {familyProductDescription_optionsList?.map((description, index) => (
                    <option key={index} value={description}>
                      {description}
                    </option>
                  ))}
                </Select>
                <div>
                  <Button
                    title='ADD'
                    type="primary"
                    onClick={handleAdd}
                    disabled={!(familyValue?.length && sizeValue?.length)}
                    style={{ marginLeft: '05px', marginTop:'10px'}}
                  />
                  <label style={{display:'flex', marginLeft: '05px'}}>
                    <input
                      type='checkbox'
                      value={showDifferences}
                      onChange={() => handleshowDifferences(!showDifferences)}
                    />
                    <div style={{marginLeft: '5px'}}>Show differences only</div>
                  </label>
                </div>
              </div>
            )}

            {selectedOption === 'PROFILE' && (
              <div>
                <div style={{margin: '5px', borderBottom: '1px solid lightgray'}}>Select Profile</div>
                <Select
                  style={{ width: '150px', margin: '5px' }}
                  onChange={handleProductChange}
                  value={productValue}
                  placeholder="Product Name"
                  dropdownStyle={{minWidth:'300px'}}
                >
                  {productTypesList?.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </Select>

                <Select
                  style={{ width: '150px', marginLeft: '5px' }}
                  onChange={handleSizeChange}
                  value={sizeValue}
                  placeholder="Size"
                  dropdownStyle={{minWidth:'300px'}}
                >
                  {selectedProductDescriptions_optionsList?.map((description, index) => (
                    <option key={index} value={description}>
                      {description}
                    </option>
                  ))}
                </Select>

                <div>
                  <Button
                    title='ADD'
                    type="primary"
                    onClick={handleAdd}
                    disabled={!(productValue?.length && sizeValue?.length)}
                    style={{ marginLeft: '05px', marginTop:'10px'}}
                  />
                </div>
                <label style={{display:'flex', marginLeft: '05px'}}>
                    <input
                      type='checkbox'
                      value={showDifferences}
                      onChange={() => handleshowDifferences(!showDifferences)}
                    />
                    <div style={{marginLeft: '5px'}}>Show differences only</div>
                  </label>
              </div>
            )}
            </div>
            }

            {addedItems.length > 0 &&
            <div style={{backgroundColor: '#EEEEEE', border: '1px solid lightgrey', padding:'5px'}}>
              <div style={{borderBottom: '1px solid lightgrey'}}>{selectedOption === 'FAMILY' ?  familyValue : "PROFILES: "}</div>
                <SimpleList
                        style={{margin: '5px', border: '1px solid lightgray'}}
                        dataSource={addedItems}
                        renderItem={(item, index) => (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '5px',
                              borderBottom: '1px solid #ccc',
                            }}
                          >
                            <div style={{  marginLeft: '15px', display:'flex' }}>
                              <div className='productInList' style={{padding:'5px', backgroundColor: '#FFFFBB', borderRadius: '5px', border: '1px solid #FF9900', margin:'2px'}}>{item.product}</div>
                              <div className='separator' style={{padding:'5px', margin:'2px'}}>:</div>
                              <div className='sizeInList'  style={{padding:'5px', backgroundColor: '#AAFFAA', borderRadius: '5px', border: '1px solid #00FF00', margin:'2px'}}>{item.size}</div>
                            </div>

                            <div>
                            <Button
                              key="btn1"
                              title='X'
                              style={{ marginLeft: 'auto' }}
                              onClick={() => handleRemove(index)}
                              size="small"
                              type="primary"
                            />
                            </div>
                          </div>
                        )}
                        itemLayout="horizontal"
                      />

            </div>
            }

          </div>):(
            <div key="dropdowns"  style={{border: '1px solid lightgray', marginLeft: '5px', padding: '5px'}}>
              {/* <Icon name='keyboard_double_arrow_right' onClick={(e) =>setSideOpen(!sideOpen)}/> */}
              <Button
                title='Open Profile Selection'
                key="insertUpButton"
                type="secondary"
                size="small"
                onClick={(e) =>setSideOpen(!sideOpen)}
                prefixIcon={{name: 'keyboard_double_arrow_right'}}
              />
            </div>
          )



          }

          {/* Data Grid Section */}
          <div key="datagrid">
            {displayDataForColumns && displayDataForColumns.length ? (
              <EditableTable
                tableData={displayDataForColumns}
                tableColumns={columnNames}
                Table_Header={`${company?.toUpperCase()  } (PRODUCTION LINE)`}
                hiddenColumns={hiddenColumns}
                showActions_ext={false}
                allowSelection={false}
                onlyAddableFields={[]}
                mandatoryFields={[]}
                groupByColours
                ColorOptions={
                  {baseColor:'#FFFFFF',
                  transparency: 0.45,
                  thickBorders: true,
                  mainGroupColumnName:'areacode',
                  subgroupColumnName: 'zonecode',
                  seed:999,
                  useTheColorOptions: true,
                }}
                clearTheSelection
              />
            ):<div>LOAIDNG DATA</div>}
          </div>
        </Grid>
      </styled.CompanyHome>
    </ThemeProvider>
  );
}

export default memo(CompanyHome) as unknown as typeof CompanyHome;
